export const reworkModeEnum = {
    deanAdmissions: 0,
    teacherReworks: 1,
};